module.exports = __webpack_public_path__ + "img/hand-back-point-down.19d6dfa3.svg";